module.exports = __webpack_public_path__ + "img/about9.8733a98.jpg";